export function Quote() {
  return (
    <section className="section-pad flex flex-col items-center border-t border-line text-center">
      <blockquote className="m-0 max-w-[20ch] text-[clamp(22px,3.6vw,44px)] font-medium leading-[1.15] tracking-[-0.03em]">
        «Свіжість — це не маркетинг. Це два тижні, поки зерно ще говорить.»
      </blockquote>
    </section>
  );
}
